__turbopack_context__.v({
  "centeredStack": "jRIruG_centeredStack",
  "content": "jRIruG_content",
  "descriptionBlock": "jRIruG_descriptionBlock",
  "flexContent": "jRIruG_flexContent",
  "flexContentGap12": "jRIruG_flexContentGap12",
  "loadingMessage": "jRIruG_loadingMessage",
  "primaryContent": "jRIruG_primaryContent",
});
